import { render } from "./wheelchairToggle.vue?vue&type=template&id=6da54d56&scoped=true"
import script from "./wheelchairToggle.vue?vue&type=script&lang=js"
export * from "./wheelchairToggle.vue?vue&type=script&lang=js"

import "./wheelchairToggle.vue?vue&type=style&index=0&id=6da54d56&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6da54d56"

export default script